import React, { useState, useEffect, useCallback, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './MyDataViewSetting.module.css';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import ToastPopup from '../../../../components/comm/ToastPopup';
import URL from '../../../../constants/url';


const MyDataViewSetting = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');


    const navigate = useNavigate();

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const location = useLocation();

    const [summaryViewInfo, setSummaryViewInfo] = useState({ ...location.state?.summaryViewInfo, usrInfoId: user.usrInfoId });

    const handleSwitchChange = (key) => (event) => {
        saveSummaryViewInfo({ ...summaryViewInfo, [key]: event.target.checked ? '1' : '0' });

        setSummaryViewInfo(prev => ({
            ...prev,
            [key]: event.target.checked ? '1' : '0',
        }));

    };

    const saveSummaryViewInfo = useCallback(async (summaryViewInfo) => {
        const url = "/mypage/saveSummaryViewInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }

        await axiosApi.post(url, summaryViewInfo, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {

                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("화면설정 저장 중 오류 : ", err);
            })
    }, [])

    if (!summaryViewInfo) return;


    return (
        <>
            {/* <HeadSub title="화면 설정" myData="on"/> */}
            <div className={"header header-sub header-mydata-box"}>
                <div className='left' onClick={() => { /* navigate(-1) */navigate('/MyPageMain'); }}>
                    <button data-icon={''}> <span className='blind'>뒤로가기</span> </button>
                    <h3>{'화면설정'}</h3>
                </div>
                <div className='my-databox' data-type="a"> <p>내 정보의 <b> 각 항목별 노출 여부</b>를 설정할 수 있습니다.</p></div>
            </div>

            <div id="sub-content" data-type='c' data-layout="white">
                <div className='inner-wrap' data-top-padding="0" >

                    <div className={style['setting-list-box']}>
                        <ul>
                            <li>
                                <p>기본 정보</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.bassInfoAt === '1'} onChange={handleSwitchChange('bassInfoAt')} size="small" />} />
                                </div>
                            </li>
                            {/* <li>
                                <p>주요 진단</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.mainDgnssAt === '1'} onChange={handleSwitchChange('mainDgnssAt')} size="small"/>} />
                                </div>
                            </li> */}
                            <li>
                                <p>알레르기</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.alrgyExprsAt === '1'} onChange={handleSwitchChange('alrgyExprsAt')} size="small" />} />
                                </div>
                            </li>
                            <li>
                                <p>과거력</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.hxExprsAt === '1'} onChange={handleSwitchChange('hxExprsAt')} size="small" />} />
                                </div>
                            </li>
                            <li>
                                <p>가족력</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.fhExprsAt === '1'} onChange={handleSwitchChange('fhExprsAt')} size="small" />} />
                                </div>
                            </li>

                            {/* 안보이도록 수정 */}
                            {/* <li>
                                <p>주요 수술/처치력</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.mainSrgctAt === '1'} onChange={handleSwitchChange('mainSrgctAt')} size="small"/>} />
                                </div>
                            </li> */}
                            <li>
                                <p>주요 약물력</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.mainMdcnAt === '1'} onChange={handleSwitchChange('mainMdcnAt')} size="small" />} />
                                </div>
                            </li>
                            <li>
                                <p>현재 복용중 약물</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.tkmdcnExprsAt === '1'} onChange={handleSwitchChange('tkmdcnExprsAt')} size="small" />} />
                                </div>
                            </li>
                            <li>
                                <p>주요 검사 결과</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.mainTstAt === '1'} onChange={handleSwitchChange('mainTstAt')} size="small" />} />
                                </div>
                            </li>
                            <li>
                                <p>주치의 정보</p>
                                <div className='swich-btn'>
                                    <FormControlLabel control={<Switch checked={summaryViewInfo?.atphsExprsAt === '1'} onChange={handleSwitchChange('atphsExprsAt')} size="small" />} />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    )
}

export default MyDataViewSetting